module.exports = __webpack_public_path__ + "img/Img39_204403_CeEt-8-1A5-1246.7196396e.jpg";